import { Reveal } from "./Reveal";
import { media } from "@/data/site";

export const Credibility = () => {
  return (
    <section className="bg-linen py-24 sm:py-36" data-testid="credibility">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 10 — CREDIBILITÀ</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight mb-10">
              Costruito da chi vive l'ecommerce ogni giorno.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5 font-sans-ui text-base sm:text-lg text-ink/70 leading-relaxed max-w-xl">
              <p>
                My Brand Online nasce da oltre 10 anni di esperienza reale nell'ecommerce fashion: advertising,
                fornitori, stock, ordini, customer service, resi, magazzino, fulfillment e logistica.
              </p>
              <p>Conosciamo ogni fase di questo processo perché la gestiamo ogni giorno, direttamente nei nostri ecommerce.</p>
              <p className="font-display italic text-2xl sm:text-3xl text-ink not-italic-none">
                Stiamo costruendo il servizio che avremmo voluto avere noi.
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="overflow-hidden bg-ivory aspect-[4/5]">
            <img src={media.editorialModel} alt="Editoriale moda" loading="lazy" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
